export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant04-de.e94bf10a.png";